export const destinations = [
  {
    id: 1,
    country: "United Kingdom",
    title: "Study in UK",
    description: "Experience world-class education in historic universities with cutting-edge research facilities",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200&q=80",
    highlights: [
      "Top-ranked universities globally",
      "Post-study work visa opportunities",
      "Rich cultural heritage",
      "Diverse student community"
    ],
    popularCities: ["London", "Manchester", "Edinburgh", "Oxford"],
    averageTuition: "£15,000 - £30,000/year"
  },
  {
    id: 2,
    country: "United States",
    title: "Study in USA",
    description: "Pursue your dreams in the land of opportunities with world-renowned institutions",
    image: "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1200&q=80",
    highlights: [
      "Ivy League institutions",
      "Cutting-edge research",
      "Flexible education system",
      "Global networking opportunities"
    ],
    popularCities: ["New York", "Boston", "Los Angeles", "San Francisco"],
    averageTuition: "$25,000 - $55,000/year"
  },
  {
    id: 3,
    country: "Canada",
    title: "Study in Canada",
    description: "Quality education in a welcoming, multicultural environment with excellent career prospects",
    image: "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=1200&q=80",
    highlights: [
      "Affordable tuition fees",
      "Post-graduation work permit",
      "Safe and welcoming society",
      "Pathway to permanent residency"
    ],
    popularCities: ["Toronto", "Vancouver", "Montreal", "Ottawa"],
    averageTuition: "CAD 15,000 - 35,000/year"
  },
  {
    id: 4,
    country: "Australia",
    title: "Study in Australia",
    description: "Enjoy high-quality education with a perfect blend of academic excellence and lifestyle",
    image: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=1200&q=80",
    highlights: [
      "World-class universities",
      "Work while you study",
      "Beautiful climate and lifestyle",
      "Strong job market"
    ],
    popularCities: ["Sydney", "Melbourne", "Brisbane", "Perth"],
    averageTuition: "AUD 20,000 - 45,000/year"
  },
  {
    id: 5,
    country: "Germany",
    title: "Study in Germany",
    description: "Access free or low-cost education in Europe's economic powerhouse",
    image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&q=80",
    highlights: [
      "Low or no tuition fees",
      "Strong engineering programs",
      "Central European location",
      "Post-study work opportunities"
    ],
    popularCities: ["Berlin", "Munich", "Hamburg", "Frankfurt"],
    averageTuition: "€0 - €20,000/year"
  },
  {
    id: 6,
    country: "New Zealand",
    title: "Study in New Zealand",
    description: "Experience innovative education in stunning natural surroundings",
    image: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=1200&q=80",
    highlights: [
      "High-quality education",
      "Safe and peaceful country",
      "Adventure and outdoor activities",
      "Work opportunities"
    ],
    popularCities: ["Auckland", "Wellington", "Christchurch", "Dunedin"],
    averageTuition: "NZD 22,000 - 32,000/year"
  }
];

export const universities = [
  {
    id: 1,
    name: "University of Oxford",
    country: "United Kingdom",
    ranking: "#1 in UK",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Oxford-University-Circlet.svg/1200px-Oxford-University-Circlet.svg.png",
    programs: ["Medicine", "Law", "Engineering", "Business"],
    tuition: "£25,000 - £35,000/year"
  },
  {
    id: 2,
    name: "Harvard University",
    country: "United States",
    ranking: "#1 in USA",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/2/29/Harvard_shield_wreath.svg/1200px-Harvard_shield_wreath.svg.png",
    programs: ["Business", "Law", "Medicine", "Computer Science"],
    tuition: "$50,000 - $60,000/year"
  },
  {
    id: 3,
    name: "University of Toronto",
    country: "Canada",
    ranking: "#1 in Canada",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/f/f6/University_of_Toronto_coat_of_arms.svg/1200px-University_of_Toronto_coat_of_arms.svg.png",
    programs: ["Engineering", "Computer Science", "Business", "Medicine"],
    tuition: "CAD 45,000 - 55,000/year"
  },
  {
    id: 4,
    name: "University of Melbourne",
    country: "Australia",
    ranking: "#1 in Australia",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/b/bd/University_of_Melbourne_Logo.svg/1200px-University_of_Melbourne_Logo.svg.png",
    programs: ["Medicine", "Law", "Engineering", "Arts"],
    tuition: "AUD 30,000 - 45,000/year"
  },
  {
    id: 5,
    name: "Technical University of Munich",
    country: "Germany",
    ranking: "#1 in Germany",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/TU_Muenchen_Logo.svg/1200px-TU_Muenchen_Logo.svg.png",
    programs: ["Engineering", "Computer Science", "Physics", "Mathematics"],
    tuition: "€0 - €3,000/year"
  },
  {
    id: 6,
    name: "University of Auckland",
    country: "New Zealand",
    ranking: "#1 in New Zealand",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/b/b8/University_of_Auckland_coat_of_arms.svg/1200px-University_of_Auckland_coat_of_arms.svg.png",
    programs: ["Business", "Engineering", "Medicine", "Arts"],
    tuition: "NZD 26,000 - 35,000/year"
  },
  {
    id: 7,
    name: "University of Cambridge",
    country: "United Kingdom",
    ranking: "#2 in UK",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/University_of_Cambridge_logo.svg/1200px-University_of_Cambridge_logo.svg.png",
    programs: ["Engineering", "Natural Sciences", "Medicine", "Law"],
    tuition: "£24,000 - £34,000/year"
  },
  {
    id: 8,
    name: "Stanford University",
    country: "United States",
    ranking: "#2 in USA",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Seal_of_Leland_Stanford_Junior_University.svg/1200px-Seal_of_Leland_Stanford_Junior_University.svg.png",
    programs: ["Computer Science", "Engineering", "Business", "Medicine"],
    tuition: "$55,000 - $65,000/year"
  }
];
